import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-item" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "col-item" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "col-item" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "col-item col-company" }
const _hoisted_13 = { class: "title" }

import { Api } from '@/http/Api';
import { ResponseCode } from '@/http/ResponseCode';
import { router } from '@/router';
import { Action, LanguageType } from '@/typeDefine/CommonTypes';
import { LanguagePackageType } from '@/typeDefine/EntityType';
import { GetSomeProductTypesResponse } from '@/typeDefine/HttpResponseType';
import { UtilMethods } from '@/util/UtilMethods';
import { nextTick, onBeforeUnmount, onMounted, ref, Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { debounce } from 'lodash-es'


export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const { t } = useI18n<[LanguagePackageType], LanguageType>()

const footerRef: Ref<Element | null> = ref(null)
const blockHeight: Ref<number> = ref(0)

const isFixed: Ref<boolean> = ref(false)

const someProductTypes: Ref<GetSomeProductTypesResponse['data']['someTypes']> = ref([])
let observer: MutationObserver | null = null

onMounted(() => {
    window.addEventListener('resize', checkFooterPosition)

    requestSomeProducType()

    observer = new MutationObserver(
        debounce(() => {
            checkFooterPosition()
        }, 100)
    )
    observer.observe(document.body, { childList: true, subtree: true })
})

//用于检测屏幕是否撑满
const checkFooterPosition: Action = () => {

    setTimeout(() => {
        const bodyHeight = document.body.scrollHeight
        const viewportHeight = window.innerHeight
        isFixed.value = bodyHeight <= viewportHeight

        nextTick(() => {
            if (!footerRef.value) {
                return
            }

            blockHeight.value = footerRef.value.getBoundingClientRect().height
        })
    }, 500);

}

//请求部分产品类别
const requestSomeProducType: Action = async () => {
    const response: GetSomeProductTypesResponse = await Api.instance.getSomeProductTypes({
        size: 5
    })

    UtilMethods.showMessageToast(response, false)

    if (response.code === ResponseCode.OK) {
        someProductTypes.value = response.data.someTypes
    }
}

//前往产品页面
const gotoProduct: Action<[number]> = (typeId: number) => {
    router.push({
        name: 'products',
        query: {
            typeId: `${typeId}`
        }
    })
}

onBeforeUnmount(() => {
    window.removeEventListener('resize', checkFooterPosition)
    observer?.disconnect()
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_Message = _resolveComponent("Message")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Phone = _resolveComponent("Phone")!
  const _component_Location = _resolveComponent("Location")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isFixed.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "block",
          style: _normalizeStyle({ 'height': blockHeight.value })
        }, null, 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['footer-content', isFixed.value ? 'fixed-bottom' : '']),
      ref_key: "footerRef",
      ref: footerRef
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_row, { gutter: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              md: 5,
              xs: 24,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('index.footer.product.title')), 1),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(someProductTypes.value, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.id
                      }, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (gotoProduct(item.id)),
                          class: "pointer-cursor"
                        }, _toDisplayString(item.name), 9, _hoisted_5)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              md: 5,
              xs: 24,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('index.footer.aboutUs.title')), 1),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.$tm('index.footer.aboutUs.item') as any), (item, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, [
                        _createElementVNode("a", {
                          href: item.path
                        }, _toDisplayString(item.name), 9, _hoisted_8)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              md: 5,
              xs: 24,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('index.footer.contactUs.title')), 1),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.$tm('index.footer.contactUs.item') as any), (item, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, [
                        _createElementVNode("a", {
                          href: item.path
                        }, _toDisplayString(item.name), 9, _hoisted_11)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              md: 9,
              xs: 24,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('index.footer.companyInfo.title')), 1),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_el_icon, { class: "icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Message)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('index.footer.companyInfo.item[0]')), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_el_icon, { class: "icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Phone)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('index.footer.companyInfo.item[1]')), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_el_icon, { class: "icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Location)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('index.footer.companyInfo.item[2]')), 1)
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ], 2)
  ]))
}
}

})